/* eslint-disable @typescript-eslint/no-explicit-any */
import { mpfRListsHttp } from '../api/mpf-r-lists-http'
import {checkForOnlySpacesOrTags} from '../general/general'

const checkForOnlySpaces = (val: string): boolean => /^\s*$/.test(val)

export const isPhoneNumberValid = (phonenumber: string): boolean => {
  let valid = false
  const numberLength = phonenumber.replace(/\s/g, '').length
  if (
    phonenumber === '' ||
    phonenumber === null ||
    checkForOnlySpaces(phonenumber)
  ) {
    valid = false
  }
  if (phonenumber && numberLength > 9 && numberLength < 14) {
    valid = true
  }
  return valid
}
export const isInputValid = (input: string): boolean => {
  let valid = false
  if (input === '' || input === null || checkForOnlySpacesOrTags(input)) {
    valid = false
  } else valid = true
  return valid
}
export const isDropDownValid = (select: null | number | string): boolean => {
  let valid = false
  if (
    select === '' ||
    select === null ||
    select === -1 ||
    select === 'Select'
  ) {
    valid = false
  } else {
    valid = true
  }
  return valid
}
export const isEmailValid = (email: string): boolean => {
  let isValidEmail = true
  if (email !== null || email !== '' || checkForOnlySpaces(email)) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!regex.test(email)) {
      isValidEmail = false
    }
  }
  return isValidEmail
}

export const isDODValid = (dodnumber: string): boolean => {
  let isDODValid = true
  if (dodnumber === null || dodnumber === '' || dodnumber.length < 10) {
    isDODValid = false
  }
  return isDODValid
}

export function isMatch(metaData: string[], value: string): boolean {
  return metaData
    .map((item) => {
      return item.toUpperCase().includes(value.toUpperCase())
    })
    .includes(true)
}

export const validateUniqueDoDID = async (
  DoD: string,
  userRID: string,
  list_name: string,
  user_rid_column: string,
  dod_column: string
) => {
  let isValid = false
  const filter = `DoDNumber eq '${DoD}'`
  const list = await mpfRListsHttp().getList(list_name)
  const hasDoD: any = await list
    .query()
    .filter(filter)
    .select(user_rid_column, dod_column)
    .get()

  if (hasDoD.length) {
    const i = hasDoD[0]
    if (i.DoDNumber === DoD && i.UserRID !== userRID) {
      isValid = false
    }
    if (i.DoDNumber === DoD && i.UserRID === userRID) {
      isValid = true
    }
    if (i.DoDNumber === undefined) {
      isValid = true
    }
  } else {
    isValid = true
  }
  return isValid
}
export const isValidURL = (url) => {
  const regex = new RegExp(
    '^(https?:\\/\\/)?' + // Optional protocol
      '((([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,})|' + // Domain
      'localhost|' + // Localhost
      '\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}|' + // IPv4
      '\\[?[a-fA-F0-9]*:[a-fA-F0-9:]+\\]?)' + // IPv6
      '(\\:\\d+)?' + // Optional port
      '(\\/[-a-zA-Z0-9@:%._\\+~#=]*)*' + // Path
      '(\\?[;&a-zA-Z0-9%_.~+=-]*)?' + // Query
      '(\\#[-a-zA-Z0-9_]*)?$' // Fragment
  )

  return regex.test(url)
}
